import React from 'react';
import { motion } from 'framer-motion';
import { QuoteIcon, StarIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { testimonials } from '../data/testimonials';
export function Testimonials() {
  return <section className="w-full bg-cream py-20 sm:py-28" aria-labelledby="testimonials-title" data-id="element-189" data-mp="3fy2zzxxfvw4k">
      <div className="mx-auto w-full max-w-6xl px-5 sm:px-8" data-id="element-190" data-mp="3b01gxd00jwt3">
        <SectionHeading eyebrow="Lo que dicen otras mujeres" title="Ellas también creían que no tenían tiempo" data-id="element-191" data-mp="36ziobgqaqmpu" />

        <div className="mt-12 grid gap-6 md:grid-cols-3" data-id="element-192" data-mp="31yl5r31djqnt">
          {testimonials.map((testimonial, index) => <motion.figure key={testimonial.name} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.3
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="flex h-full flex-col rounded-3xl border border-plum/10 bg-white/60 p-7" data-id="element-193" data-mp="2x2w50wdmc3px" data-mpi={index}>
              <QuoteIcon className="h-6 w-6 text-clay/60" aria-hidden="true" data-id="element-194" data-mp="h4n4idrci3bz" />
              <div className="mt-4 flex" aria-label="5 de 5 estrellas" data-id="element-195" data-mp="m5sx8bl09qli">
                {[0, 1, 2, 3, 4].map(i => <StarIcon key={i} className="h-4 w-4 fill-clay text-clay" aria-hidden="true" data-id="element-196" data-mp="79li3pogffd3" />)}
              </div>
              <blockquote className="mt-4 flex-1 text-base leading-relaxed text-ink/80" data-id="element-197" data-mp="zwpp2073y3ri">
                {testimonial.quote}
              </blockquote>
              <figcaption className="mt-6 border-t border-plum/10 pt-4 text-sm font-medium uppercase tracking-[0.16em] text-plum" data-id="element-198" data-mp="14uzmyik7vigt">
                {testimonial.name}
                <span className="ml-2 font-normal normal-case tracking-normal text-ink/55" data-id="element-199" data-mp="v4xu7dgx5bvk">
                  {testimonial.location}
                </span>
              </figcaption>
            </motion.figure>)}
        </div>

        <p className="mt-12 text-center font-display text-2xl leading-snug text-plum sm:text-3xl" data-id="element-200" data-mp="1nnbkmrzxdvkm">
          Ya más de 700 mujeres dieron este primer paso.
          <br className="hidden sm:block" data-id="element-201" data-mp="1sie7qu63s3mo" /> Y empezaron a regresar a sí mismas.
        </p>
      </div>
    </section>;
}